/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { Validator } from '@squiz/dxp-console-support';

/**
 * Validates an event subscription target URL.
 * @export
 * @class TargetUrlValidator
 * @extends {Validator<unknown, R>}
 * @template R
 */
export class TargetUrlValidator<R> extends Validator<unknown, R> {
  public doValidate(value: unknown): boolean {
    const expression = /^[(www.)?a-zA-Z0-9@:%._+~#-=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)$/;
    return expression.test(String(value).trim());
  }
}
